import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {NEWS} from "../news-widget.consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {NewsWidgetArticleDisplayEvent} from "../models/news-widget.article-display.event";

export class NewsWidgetArticleDisplayHandler extends AnalyticsEventHandler {
  type = NEWS.ACTION_TYPES.onArticleDisplay;

  static injectables = [...AnalyticsEventHandler.injectables];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NewsWidgetArticleDisplayEvent;
  }
}
